'use client';

import { Credits } from './Credits';
import { Toast, ToastTile } from './Toast';
import { FaGift } from '@/components/icons';
import { AchievementIcon } from '@/screens/AchievementsScreen/components/AchievementIcon';
import { useLocalTranslation } from '@/hooks/useLocalTranslation';
import translations from './AchievementUnlockToast.translations';

interface Props {
  iconFile: string;
  title: string;
  rewardCredits?: number;
  rewardXp?: number;
  claimed?: boolean;
  onClick?: () => void;
  onDismiss?: () => void;
}

export function AchievementUnlockToast({
  iconFile,
  title,
  rewardCredits,
  rewardXp,
  claimed = true,
  onClick,
  onDismiss,
}: Props) {
  const { t } = useLocalTranslation(translations);
  const hasReward = !!rewardCredits || !!rewardXp;

  const icon = (
    <>
      <div className="pointer-events-none absolute inset-0 scale-[1.5] opacity-40 blur-[14px]">
        <AchievementIcon iconFile={iconFile} alt="" fill className="object-contain" />
      </div>
      <div className="animate-shot-ach-icon-pop relative h-full w-full">
        <AchievementIcon iconFile={iconFile} alt={title} fill className="object-contain" />
      </div>
    </>
  );

  let reward = null;
  if (hasReward && claimed) {
    reward = (
      <>
        {!!rewardCredits && (
          <span className="inline-flex items-center gap-0.5 text-xs font-semibold text-price">
            +<Credits amount={rewardCredits} iconSize={11} />
          </span>
        )}
        {!!rewardXp && <span className="text-xs font-semibold text-label-secondary">+{rewardXp} {t('xp')}</span>}
      </>
    );
  } else if (hasReward) {
    reward = (
      <span className="flex items-center gap-1 text-xs font-semibold text-price">
        <FaGift size={10} />
        {!!rewardCredits && (
          <span className="inline-flex items-center gap-0.5">
            +<Credits amount={rewardCredits} iconSize={10} />
          </span>
        )}
        <span className="text-price/90">· {t('claimReward')} →</span>
      </span>
    );
  }

  return (
    <Toast
      leading={<ToastTile>{icon}</ToastTile>}
      overline={t('unlocked')}
      title={title}
      description={reward}
      accent="amber"
      onClick={onClick}
      onDismiss={onDismiss}
    />
  );
}
